import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { EventStatus } from 'enums/modules/event/eventStatus';
import { EventListItem } from 'model/modules/events/eventList';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import TagsRow from 'presentation/components/shared/TagsRow';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

interface Props {
  data: EventListItem;
  height?: number;
}

const EventGridItem: FC<Props> = ({ data, height = 250 }) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const cardHeight = `${height}px`;

  return (
    <AppCard
      position="relative"
      h={cardHeight}
      overflow="hidden"
      onClick={() => navigate(AppRoute.eventDetail(data.id))}
      cursor="pointer"
    >
      <Image
        zIndex={1}
        src={data.preview}
        pos="absolute"
        h={cardHeight}
        w="full"
        objectFit="cover"
      />
      <Box
        zIndex={2}
        pos="absolute"
        h={cardHeight}
        w="full"
        bgImage="linear-gradient(181.93deg,rgba(57,57,57,0) 1.63%,hsla(0,0%,7%,.7) 67.7%)"
        borderRadius="16px"
      />
      <Flex
        zIndex={3}
        pos="relative"
        flexDir="column"
        justifyContent="space-between"
        p="15px"
        h="100%"
      >
        <TagsRow
          tags={[
            data.status === EventStatus.Upcoming
              ? t('eventStatusUpcomingTag')
              : t('eventStatusArchivedTag'),
            moment(data.startDate).format('DD.MM.yyyy'),
          ]}
          justifyContent="flex-end"
        />
        <Box>
          <Text color="#fff" fontSize="22px" fontWeight={800}>
            {data.name}
          </Text>
          <Text color="#fff" fontSize="14px">
            {data.subtitle}
          </Text>
        </Box>
      </Flex>
    </AppCard>
  );
};

export default EventGridItem;
